import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useWaitlistCount = () => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWaitlistCount = async () => {
      try {
        const { data: waitlistCount, error } = await supabase
          .rpc('get_waitlist_count');
        
        if (error) throw error;
        
        // Add 11 to the actual count for social proof
        setCount((waitlistCount || 0) + 11);
      } catch (error) {
        console.error('Error fetching waitlist count:', error);
        // Fallback count if error occurs
        setCount(11);
      } finally {
        setLoading(false);
      }
    };

    fetchWaitlistCount();
  }, []);

  return { count, setCount, loading };
};